import { render } from "./ViewDirectLogin.vue?vue&type=template&id=259b61bb"
import script from "./ViewDirectLogin.vue?vue&type=script&lang=js"
export * from "./ViewDirectLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__